(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wd-shop-the-look-carousel"] && !Shopify.designMode) return;
  try {
    const handleLookIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(lookRecommendationsSection);

    const url = lookRecommendationsSection.dataset.url;
    if (!url) return;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const fetched = html.querySelector('#wd-stl-section');
        if (!fetched) return;

        const fetchedSlides = fetched.querySelectorAll('.wd-stl-slide');
        console.log('[STL] Complementary slides found:', fetchedSlides.length);

        if (fetchedSlides.length > 0) {
          lookRecommendationsSection.innerHTML = fetched.innerHTML;
        }
      })
      .catch(e => console.error('[STL] Fetch error:', e));
  };

  const lookRecommendationsSection = document.querySelector('#wd-stl-section');
  if (lookRecommendationsSection) {
    const observer = new IntersectionObserver(handleLookIntersection, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(lookRecommendationsSection);
  }
  } catch(e) { console.error(e); }
})();

})();
